import { Time } from './time';
import { VenueConfiguration, VenueTemplate } from './venueTemplate';
import { Property } from './property';
import { WithId } from './typeUtils';
import { GroupParty } from './groupParty';
import { User } from './user';
import { BufferTime } from './zod/groupEvent';
import { GroupResource } from './zod/groupResource';

export interface VenueResourceRequest {
  name: string;
  amount: number;
}

export type VenueRequestStatus =
  | 'pending'
  | 'approved'
  | 'modified'
  | 'rejected'
  | 'cancelled'
  | 'draft';
export const venueRequestStatuses: VenueRequestStatus[] = [
  'pending',
  'approved',
  'modified',
  'rejected',
  'cancelled',
  'draft',
];

// A simpler user type just for book-keeping purposes
export interface VenueRequestUser {
  _id: string;
  firstName: string;
  lastName: string;
  email: string;
}

export interface VenueRequestComment {
  status?: VenueRequestStatus;
  message: string;
  date: Date;
  user: VenueRequestUser;
}

export interface VenueRequestFile {
  _id: string;
  name: string;
  location: string;
}

export interface BareVenueRequest {
  _id: string;
  venue: string;
  name: string;
  numGuests: number;
  startTime: Time;
  duration: number;
  date: Date;
  dayIndex: number;
  status: VenueRequestStatus;
  resources: Resource[];
  packages: string[];
  dining?: string;
  comments: VenueRequestComment[];
  notes: string;
  files: VenueRequestFile[];
  createdBy: string;
  venueConfig?: string;
  subgroup?: string;
  bufferTime: BufferTime;
}

// name, archived and price are only used for display purposes. do not rely on them for logic
// if you need them use GroupResource
export type Resource = Pick<GroupResource, 'name' | 'resourceType' | 'archived'> & {
  resourceId: string;
  amount: number;
  id: string;
  price: number;
};

export type VenueRequest = Omit<
  BareVenueRequest,
  'venue' | 'createdBy' | 'subgroup' | 'venueConfig'
> & {
  venue: VenueTemplate;
  createdBy: User;
  subgroup?: GroupSubgroup;
  venueConfig?: VenueConfiguration;
  resources?: Resource[];
};

export interface GroupSubgroup {
  _id: string;
  label: string;
  name: string;
  groupGuideName: string;
  groupGuideCabin: string;
  attendees: number;
  files: VenueRequestFile[];
  notes: string;
}
export interface NewGroupBooking {
  property: string;
  date: Date;
  party: GroupParty;
  salesOffice?: string;
  requests: BareVenueRequest[];
  subgroups: GroupSubgroup[];
}

export type BareGroupBooking = NewGroupBooking & {
  createdBy: string;
  archived: boolean;
} & WithId;

export type GroupBooking = Omit<BareGroupBooking, 'property' | 'createdBy' | 'requests'> & {
  property: Property;
  createdBy: User;
  requests: VenueRequest[];
};

export type BareSimpleGroupBooking = Omit<BareGroupBooking, 'requests' | 'subgroups'>;
